import { render, staticRenderFns } from "./VistaEditarComisiones.vue?vue&type=template&id=02c670b7"
import script from "./VistaEditarComisiones.vue?vue&type=script&lang=js"
export * from "./VistaEditarComisiones.vue?vue&type=script&lang=js"
import style0 from "./VistaEditarComisiones.vue?vue&type=style&index=0&id=02c670b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports